import { ActionStatus } from '../types/enums/action-status.enum'

type Callbacks<T> = {
  onSuccess?: (result: T) => void
  onError?: (result: T) => void
}

export const withCallbacksServerAction = <
  Args extends unknown[],
  T extends { status?: ActionStatus; error?: string; message?: string },
>(
  fn: (...args: Args) => Promise<T>,
  callbacks: Callbacks<T>,
): ((...args: Args) => Promise<T>) => {
  return async (...args: Args) => {
    const promise = fn(...args)

    const result = await promise

    if (result?.status === ActionStatus.SUCCESS) {
      callbacks.onSuccess?.(result)
    }

    if (result?.status === ActionStatus.ERROR) {
      callbacks.onError?.(result)
    }

    return promise
  }
}
